<template>
  <v-card class="pa-md-4" color="transparent" flat>
    <v-card color="transparent" max-width="600" flat style="margin: auto">
      <div>
        <v-text-field
          placeholder="Buscar"
          v-model="searchText"
          prepend-inner-icon="search"
          clearable
          rounded
          hide-details
          outlined
        ></v-text-field>
      </div>
    </v-card>
    <p class="body-1 font-weight-medium text-center pt-6 primary--text">
      Contamos con una lista de más de 700 especies, busca por
      <span class="font-weight-bold">nombre científico o común</span> y agrega
      la especie a tu buceo
    </p>

    <div v-if="loading" class="d-flex mt-8" style="overflow:auto;">
      <v-card
        v-for="(item, index) of [1, 2, 3, 4, 5]"
        :key="index"
        class="ma-2"
        min-width="280"
        width="280"
      >
        <v-skeleton-loader
          class="mx-auto"
          type="list-item-avatar-two-line"
        ></v-skeleton-loader>
      </v-card>
    </div>
    <div v-else class="d-flex flex mt-8 mb-4">
      <div
        v-if="organismList.length == 0"
        class="flex d-flex align-center justify-center pa-8"
        style="overflow:auto;"
      >
        <span class="font-weight-light body-2"
          >No se encontraron resultados</span
        >
      </div>
      <v-slide-group show-arrows v-else>
        <template v-slot:prev>
          <v-btn fab small color="#c0e2e6">
            <v-icon color="primary">mdi-chevron-left</v-icon>
          </v-btn>
        </template>
        <template v-slot:next>
          <v-btn fab small color="#c0e2e6">
            <v-icon color="primary">mdi-chevron-right</v-icon>
          </v-btn>
        </template>
        <v-slide-item v-for="organism of organismList" :key="organism.id">
          <v-card dark class="ma-2 primary" width="200">
            <OrganismProfilePicture :id="organism.id"></OrganismProfilePicture>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{
                  organism.vernacularName || "s/nombre común"
                }}</v-list-item-title>
                <v-list-item-subtitle
                  class="caption"
                  style="font-style:italic;"
                  >{{
                    organism.scientificName || "s/nombre científico"
                  }}</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon rounded outlined @click="onSelect(organism)">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </div>
    <OrganismRequestBox></OrganismRequestBox>
  </v-card>
</template>

<script>
import api from "../../api.js";
import OrganismProfilePicture from "../Organism/OrganismProfilePicture";
import OrganismRequestBox from "./OrganismRequestBlock";
import SvgIcon from "@/components/SvgIcon";
export default {
  components: { OrganismProfilePicture, OrganismRequestBox, SvgIcon },
  data: () => ({
    apiURL: api.baseURL,
    searchText: "",
    organismList: [],
    organismSelected: {},
    loading: true,
    _timerId: null
  }),
  methods: {
    async getList() {
      try {
        this.loading = true;
        let { data: organismList } = await this.$http.get("organism", {
          params: {
            where: {
              validated: true,
              deleted: false,
              searchText: { contains: (this.searchText || "").toLowerCase() }
            },
            sort: "ocurrenceFrecuency DESC"
          }
        });
        this.organismList = organismList;
      } catch (err) {
        // console.log(err);
      }
      this.loading = false;
    },
    onSelect(item) {
      this.$emit("select", item);
    }
  },
  async mounted() {
    this.getList();
  },
  watch: {
    searchText() {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        this.getList();
      }, 800);
    }
  }
};
</script>

<style></style>
